<template>
  <div class="categoty-icon">
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <img :src="require(`@/assets/${image}`)" alt="" v-on="on">
      </template>
      <span>{{ category }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'CategoryIcon',
  props: {
    category: {
      type: String,
      required: true,
    },
  },
  computed: {
    image() {
      if (this.category === 'language') {
        return 'icon-language-white.png';
      } else if (this.category === 'mathematics') {
        return 'icon-math-white.png';
      } else if (this.category === 'general') {
        return 'icon-globe-white.png';
      }
      return 'icon_puzzle-white.png';
    },
  },
};
</script>

<style lang="scss" scoped>
.categoty-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  height: 50px;
  width: 50px;
  background: #4255FF;
  border-radius: 10px;
  position: relative;

  img {
    width: 30px;
    height: 30px;
    margin-top: 5px;
  }
}

</style>
